<template>
  <div class="ListMcc">
    <HeaderPage>
      <el-button style="height: 44px; margin-left: 1rem" @click="dialogEditAdd = true">Adicionar</el-button>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <div class="box-filter">
        <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
          <el-row :gutter="20">
            <el-col :sm="24" :md="24">
              <div class="textfilter">
                <el-input size="large" v-model="ruleForm.searchInput" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search" native-type="submit" @click.prevent="searchTable" />
                </el-input>
                <el-tooltip v-if="ruleForm.searchInput" effect="dark" content="Limpar Filtro" placement="top">
                  <el-button @click="clearSearch" type="text" class="clear-filter">
                    <XIcon size="1.5x" />
                  </el-button>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="id" label="#" width="80">
        </el-table-column>
        <el-table-column prop="name" label="Nome">
        </el-table-column>
        <el-table-column prop="limit_per_transaction" label="Limite Transação" width="200">
          <template slot-scope="scope">
            {{scope.row.limit_per_transaction | toR$}}
          </template>
        </el-table-column>
        <el-table-column prop="limit_per_day" label="Limite Dia" width="200">
          <template slot-scope="scope">
            {{scope.row.limit_per_day | toR$}}
          </template>
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog(scope.row.id)">
              <EditIcon size="1.2x" style="padding: 0 7px;"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
    <dialogEditAddMcc :show="dialogEditAdd" :idConta="idConta" @close="closeDialog" />
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {getMCC} from "@/app/domains/Config/services";
import {EditIcon} from "vue-feather-icons";
import dialogEditAddMcc from "@/app/domains/Config/components/mcc/dialogEditAddMcc";
import { XIcon } from "vue-feather-icons";

export default {
  name: "ListMcc",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    dialogEditAddMcc,
    XIcon,
  },
  data () {
    return {
      dialogEditAdd: false,
      loadingPage: true,
      idConta: '',
      listData: {},
      ruleForm: {
        searchInput: ''
      },
    }
  },
  methods: {
    init () {
      this.listMCC()
    },
    closeDialog() {
      this.idConta = ''
      this.dialogEditAdd = false
      this.init()
    },
    openDialog (id) {
      this.dialogEditAdd = true
      this.idConta = id
    },
    paginationClick (arg) {
      this.listMCC('?page='+arg.page)
    },
    async listMCC (query = '') {
      this.loadingPage = true
      try {
        let response = await getMCC(query)
        this.listData = response.data
      } catch (e) {
        this.$message({
          showClose: true,
          message: 'Erro ao carregar lista',
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    clearSearch () {
      this.$set(this.ruleForm, 'searchInput', '')
      this.init()
    },
    searchTable () {
      this.listMCC('?name='+this.ruleForm.searchInput)
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
